import React, { useContext, useState } from 'react';
import classNames from 'classnames';

import { CustomerContext } from 'context/customer';

import IconProfile from 'components/shared/SVG/IconProfile';
import DropdownMenu from './DropdownMenu/DropdownMenu';

import styles from './AuthDropdown.module.scss';

function AuthDropdown() {
  const { user } = useContext(CustomerContext);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const authButtonText = user ? `Hi, ${user.first_name}` : 'Log In or Sign Up';

  function toggleDropdown(): void {
    setShowDropdown(!showDropdown);
  }

  return (
    <div>
      <button
        className={classNames(styles.authBtn, { [styles.capitalize]: !!user })}
        onClick={toggleDropdown}
        type="button"
      >
        <IconProfile />
        {authButtonText}
      </button>
      {showDropdown && <DropdownMenu isAuthed={!!user} toggleDropdown={toggleDropdown} />}
      <div
        className={classNames(styles.dropdownOverlay, {
          [styles.visible]: showDropdown,
        })}
        onClick={toggleDropdown}
        aria-hidden
      />
    </div>
  );
}

export default AuthDropdown;
